<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'BlocPreviewRessourceHubRessources'
});
</script>
<template>
  <ka-container
    code="bloc-preview-ressource-hub-ressources"
    :options="$merge({ hidden: null }, options)"
    :instance-class="instanceClass"
    :slots="$slots"
    :inner="inner"
    :xs="xs"
    :sm="sm">
    <template #label>
      <slot name="label" />
    </template>
    <ka-image
      code="image"
      :options="{
        animationIn: `fadeIn`,
        lazyOptions: {
          throttle: 200,
          once: true,
          intersection: { threshold: 0.1 }
        },
        imgFit: `cover`
      }"
      :value="componentInstance.$picture.value" />
    <ka-text
      code="text"
      :value="componentInstance.$creerMonAutoEntreprise.value" />
    <ka-text
      code="text-1"
      :value="componentInstance.$loremIpsumDolorSit.value" />
    <!-- Container -->
    <ka-container code="container">
      <ka-button
        code="indication"
        :options="{ ripple: true }"
        :value="componentInstance.$indication.value" />
    </ka-container>
    <ka-text code="consulter">
      <span v-html="t('blocPreviewRessourceHubRessources.consulter.value', `Consulter >`)" />
    </ka-text>
  </ka-container>
</template>

<script setup lang="ts">
import { syncComponentStore } from 'kapix-components-vue3'
import { blocPreviewRessourceHubRessourcesComponent } from './store'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--c42')
const component = blocPreviewRessourceHubRessourcesComponent()
const componentInstance = component.newStoreInstance()
const props = withDefaults(defineProps<{
  creerMonAutoEntreprise?: Nullable<string>
  loremIpsumDolorSit?: Nullable<string>
  indication?: Nullable<string>
  picture?: Nullable<string | File>
  instanceClass?: Nullable<string>
  options?: Nullable<KeyValuePair>
  sm?: Nullable<KeyValuePair>
  xs?: Nullable<KeyValuePair>
  inner?: Nullable<boolean>
}>(), {
  creerMonAutoEntreprise: '<strong>Créer mon auto-entreprise</strong>',
  loremIpsumDolorSit: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis...',
  indication: 'Programme de formation',
  picture: 'https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wyOTM3MTZ8MHwxfHNlYXJjaHwxfHxjYXR8ZW58MHx8fHwxNjkyMjYyOTA3fDA&ixlib=rb-4.0.3&q=80&w=1080',
  instanceClass: undefined,
  options: undefined,
  sm: undefined,
  xs: undefined,
  inner: undefined
})

const emit = defineEmits([
  'update:creerMonAutoEntreprise',
  'update:loremIpsumDolorSit',
  'update:indication',
  'update:picture'
])
componentInstance.$emit = emit

syncComponentStore(componentInstance, {
  props,
  propsToWatch: {
    creerMonAutoEntreprise: true,
    loremIpsumDolorSit: true,
    indication: true,
    picture: true
  }
})
</script>
